import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getExecutionLog } from "../../redux/actions/logActions";
import { fetchFlowRunnerStatus } from "../../redux/actions/integrationActions";
import { addMessage, toggleLoading } from "../../redux/actions/messageActions";
import Button from "@atlaskit/button/new";
import { Flex, Flex1 } from "../../common/style";
import FlowSelectList from "../flow/components/FlowSelectList";
import DeleteLogButton from "./DeleteLogButton";
import DateTimePicker from "./DateTimePicker";
import { Box, Inline } from "@atlaskit/primitives";
const LogFilters = ({ isGlobal, flowId, actionId, showDelete = !isGlobal }) => {
  const dispatch = useDispatch();
  const [selectedFlowId, setSelectedFlowId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [hasFetchedLogs, setHasFetchedLogs] = useState(false);

  const logs = useSelector((state) => state.integration.logs);

  useEffect(() => {
    const currentFlowId = flowId ? flowId : selectedFlowId;
    if (logs && logs.length === 0 && !hasFetchedLogs && currentFlowId) {
      dispatch(getExecutionLog(currentFlowId, startDate, endDate, null, actionId));
      dispatch(toggleLoading(true, "Loading..."));
      setHasFetchedLogs(true);
    }
  }, [logs, flowId, actionId]);

  const filterLog = () => {
    if (!selectedFlowId && !flowId) {
      dispatch(addMessage("Filter missing", "An Integration needs to be selected", "info"));
      return;
    }
    const targetFlowId = flowId ? flowId : selectedFlowId;
    dispatch(getExecutionLog(targetFlowId, startDate, endDate, null, actionId));
    if (targetFlowId) {
      dispatch(fetchFlowRunnerStatus(targetFlowId));
    }
    dispatch(toggleLoading(true, "Loading..."));
  };
  const onChange = (dates) => {
    setStartDate(dates[0].valueOf());
    setEndDate(dates[1].valueOf());
  };
  const onChangeStart = (dates) => {
    setStartDate(dates);
  };
  const onChangeEnd = (dates) => {
    setEndDate(dates);
  };
  return (
    <>
      <Flex>
        {isGlobal && (
          <Flex1>
            <FlowSelectList callback={(fid) => setSelectedFlowId(fid)} isCompact={false} />
          </Flex1>
        )}
        <Inline>
          <DateTimePicker onFromChange={onChangeStart} onToChange={onChangeEnd}></DateTimePicker>
          <Box style={{ marginLeft: "2px" }}>
            <Button appearance="primary" className="log-button" onClick={filterLog}>
              Filter
            </Button>
          </Box>
        </Inline>
        <div className=".ihub-flex1"></div>

        {!isGlobal && showDelete && <DeleteLogButton />}
      </Flex>
      <Flex>
        <Flex1 className="margin-top-standard" />
      </Flex>
    </>
  );
};
export default LogFilters;
